export class BuildingStory {

  id: string
  length?: number
  width?: number
  livingSpace?: number
  ceilingHeight?: number
  topStory: boolean = false
  bottomStory: boolean = false

  constructor(object?: Partial<BuildingStory>) {
    this.id = crypto.randomUUID()

    if (object) {
      Object.assign(this, object)
    }
  }
}
